import React from 'react';
import { CalendarPlus } from 'lucide-react';
import { Button } from './button';
import {
  DropdownMenu,
  DropdownMenuContent,
  DropdownMenuItem,
  DropdownMenuTrigger,
} from './dropdown-menu';

const parseTime = (str) => {
  const m = /(\d{1,2}):(\d{2})\s*(AM|PM)/i.exec(str || '');
  if (!m) return { h: 18, min: 0 };
  let h = parseInt(m[1], 10) % 12;
  if (m[3].toUpperCase() === 'PM') h += 12;
  return { h, min: parseInt(m[2], 10) };
};

const getTimes = (event) => {
  const [startStr, endStr] = (event.time || '').split('-').map((s) => s.trim());
  const start = parseTime(startStr);
  const end = endStr ? parseTime(endStr) : { h: start.h + 1, min: start.min + 30 };
  const fmt = ({ h, min }) => {
    const extra = Math.floor(min / 60);
    return `${event.date.replace(/-/g, '')}T${String(h + extra).padStart(2, '0')}${String(min % 60).padStart(2, '0')}00`;
  };
  return { dtStart: fmt(start), dtEnd: fmt(end) };
};

export const AddToCalendarButton = ({ event, testId }) => {
  const { dtStart, dtEnd } = getTimes(event);

  const openGoogle = () => {
    const params = new URLSearchParams({
      action: 'TEMPLATE',
      text: event.title,
      dates: `${dtStart}/${dtEnd}`,
      ctz: 'America/New_York',
      location: event.location || '',
      details: event.description || '',
    });
    window.open(`https://calendar.google.com/calendar/render?${params}`, '_blank', 'noopener');
  };

  const downloadIcs = () => {
    const esc = (s) => String(s || '').replace(/\\/g, '\\\\').replace(/;/g, '\\;').replace(/,/g, '\\,').replace(/\n/g, '\\n');
    const ics = [
      'BEGIN:VCALENDAR',
      'VERSION:2.0',
      'PRODID:-//WCLC//wclcnc.com//EN',
      'BEGIN:VEVENT',
      `UID:${event.id}@wclcnc.com`,
      `DTSTART;TZID=America/New_York:${dtStart}`,
      `DTEND;TZID=America/New_York:${dtEnd}`,
      `SUMMARY:${esc(event.title)}`,
      `LOCATION:${esc(event.location)}`,
      `DESCRIPTION:${esc(event.description)}`,
      'END:VEVENT',
      'END:VCALENDAR',
    ].join('\r\n');
    const url = URL.createObjectURL(new Blob([ics], { type: 'text/calendar;charset=utf-8' }));
    const a = document.createElement('a');
    a.href = url;
    a.download = `${event.title.replace(/[^a-z0-9]+/gi, '-').toLowerCase()}.ics`;
    document.body.appendChild(a);
    a.click();
    a.remove();
    URL.revokeObjectURL(url);
  };

  return (
    <DropdownMenu>
      <DropdownMenuTrigger asChild>
        <Button
          variant="outline"
          data-testid={testId}
          className="w-full border-[#bd8cae] text-[#a3688f] hover:bg-[#bd8cae]/15"
        >
          <CalendarPlus className="w-4 h-4 mr-2" />
          Add to Calendar
        </Button>
      </DropdownMenuTrigger>
      <DropdownMenuContent align="center" className="bg-white">
        <DropdownMenuItem onClick={openGoogle} data-testid={`${testId}-google`}>
          Google Calendar
        </DropdownMenuItem>
        <DropdownMenuItem onClick={downloadIcs} data-testid={`${testId}-ics`}>
          Apple / Outlook (.ics)
        </DropdownMenuItem>
      </DropdownMenuContent>
    </DropdownMenu>
  );
};
